import * as React from 'react';
import {Query} from 'react-apollo';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSessionUser as GetSessionUserQuery,
    SessionUser as SessionUserFragment,
} from 'nutshell-graphql-types';

import GET_SESSION_USER from './graphql/queries/get-session-user.graphql';

type OwnProps = {
    children: (arg1: ChildrenProps) => React.ReactElement;
};

type ChildrenProps = {
    user: SessionUserFragment | null | undefined;
    errorMessage: string | null | undefined;
};

class SessionUserQuery extends Query<GetSessionUserQuery, Record<any, any>> {}

export const GetSessionUser = (props: OwnProps) => {
    return (
        // @ts-expect-error
        <SessionUserQuery query={GET_SESSION_USER} fetchPolicy='cache-and-network'>
            {({data, error}) => {
                const loggedInUser = data ? data.loggedInUser : null;

                return props.children({
                    user: loggedInUser,
                    // @ts-expect-error
                    errorMessage: safelyGetGraphQLErrorMessage(error),
                });
            }}
        </SessionUserQuery>
    );
};
